import React, { useState } from "react";
import classnames from "classnames/bind";
import { observer } from "mobx-react";

import Icon from "@components/icon";
import Tooltip from "@components/tooltip";

import numberFormat from "ati-utils/numberFormat";

import Refresh from "./Refresh";
import RefreshAnswer from "./RefreshAnswer";

import { sendNavigationMetric } from "../../../../../utils/sendMetric";

import { useStore } from "../../../../../connect";

import strings from "../../../../../locales/strings";

import styles from "../ProfileDropdown.scss";

const cx = classnames.bind(styles);

const Balance = () => {
  const { profile, baseUrl } = useStore();
  const [refreshHovered, setRefreshHovered] = useState(false);

  const onMouseEnterRefresh = () => {
    setRefreshHovered(true);
  };

  const onMouseLeaveRefresh = () => {
    setRefreshHovered(false);
  };

  return (
    <a
      className={cx("profile-button", "balance-link")}
      href={`https://billing.${baseUrl}/addinvoice?option=4&utm_source=header&utm_campaign=new_header`}
      onClick={() => sendNavigationMetric("PROFILE_BALANCE")}
    >
      <span className={cx("info-block")}>
        <span className={cx("balance-text")}>
          {strings.score}
          <span className={cx("balance-value")}>
            {numberFormat(profile.user.balance) || 0} {strings.profile_atis}
          </span>
        </span>

        <span className={cx("icons-block")}>
          <Refresh
            onMouseEnter={onMouseEnterRefresh}
            onMouseLeave={onMouseLeaveRefresh}
            action={profile.refreshBalance.refresh}
            loading={profile.refreshBalance.loading}
            disabled={profile.refreshBalance.disabled}
          />
          <Tooltip
            content={strings.accountReplenishment}
            duration={[null, null]}
          >
            <Icon
              className={cx("plus-icon", { hovered: refreshHovered })}
              name="ic_add-out"
              size="s"
              color="var(--glz-color-neutral-tone-5)"
            />
          </Tooltip>
        </span>
      </span>

      {profile.refreshBalance.error && !profile.refreshBalance.loading && (
        <RefreshAnswer text={profile.refreshBalance.error} />
      )}
    </a>
  );
};

export default observer(Balance);
